// extracted by mini-css-extract-plugin
export default {"inputDocumentoIdentidad":"styles_inputDocumentoIdentidad__t-ePO"};